export const FOLLOWING_TYPE = {
  QUESTION: 'Q',
  TOPIC: 'T',
  USER: 'P',
  INSTITUTION: 'I',
}
